module.exports = __webpack_public_path__ + "static/media/search.eab97d05.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/styles/images/sp/search.svg
// module id = 973
// module chunks = 0